import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { SiteHeader } from "@/components/layout/SiteHeader";
import { SiteFooter } from "@/components/layout/SiteFooter";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceCaseStudyPage from "@/pages/ServiceCaseStudyPage";
import AthletesPage from "@/pages/AthletesPage";
import PartnershipsPage from "@/pages/PartnershipsPage";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  return null;
};

const AppLayout = ({ children }) => (
  <div className="min-h-screen bg-background text-foreground">
    <SiteHeader />
    <main className="px-4 pb-8 pt-24 sm:px-6 lg:px-10" data-testid="main-content-area">
      <div className="mx-auto mb-7 h-[2px] w-full max-w-7xl rounded-full tricolor-divider opacity-75" data-testid="tricolor-divider" />
      {children}
    </main>
    <SiteFooter />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/case-study/:slug" element={<ServiceCaseStudyPage />} />
          <Route path="/athletes" element={<AthletesPage />} />
          <Route path="/partnerships" element={<PartnershipsPage />} />
        </Routes>
      </AppLayout>
      <Toaster richColors position="top-right" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
